export default function Header() {
    return (
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-6">
        <h1 className="text-2xl sm:text-3xl font-bold text-foreground mb-2">
          Quote Management
        </h1>
        <p className="text-sm sm:text-base text-muted-foreground">
          Manage and track your submitted quotes and RFQ responses
        </p>
      </div>
    )
}
